import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WebsiteOrdersState } from "../../../types";
import { axiosObj } from "../../../../config/apiClients";

const initialState: WebsiteOrdersState = {
  isLoading: false,
  orders: [],
  order: null,
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllOrders = createAsyncThunk(
  "/esouq/webOrder/getAll",
  async ({ paramPage, paramLimit, search, metalType }: { paramPage: number; paramLimit: number, search?: string, metalType: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get(`/esouq/webOrder/getAll?paramPage=${paramPage}&paramLimit=${paramLimit}${search ? `&search=${search}` : ""}${metalType ? `&metalType=${metalType}` : ""}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Website Orders' });
    }
  }
);

export const getOrderById = createAsyncThunk(
  "/esouq/webOrder/getOrderById",
  async (orderId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/esouq/webOrder/getById', { _id: orderId });

      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Website Orders' });
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "/esouq/webOrder/admin/updateStatus",
  async ({ id, status }: { id: string; status: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/esouq/webOrder/updateStatus', { _id: id, status });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Orders' });
    }
  }
);

const websiteOrdersSlice = createSlice({
  name: "websiteOrders",
  initialState,
  reducers: {
    orderStatusUpdate: (state, action) => {
      const orderStatus = action.payload;
      const order = state.orders.find((order) => order._id === orderStatus.id)
      if (order) {
        order.status = orderStatus.status;
      }
    },
    resetOrders(state) {
      state.orders = [];
      state.pagination = {
        totalItems: 0,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orders = action.payload.payload.allWebOrders;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllOrders.rejected, (state) => {
        state.isLoading = false;
        state.orders = [];
      })
      .addCase(getOrderById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.order = action.payload.payload;
      })
      .addCase(getOrderById.rejected, (state) => {
        state.isLoading = false;
        state.order = null
      });
  },
})

export const { orderStatusUpdate, resetOrders } = websiteOrdersSlice.actions;

export default websiteOrdersSlice.reducer;